import React from "react";

const Cardiology = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-2xl mt-10">
      {/* Header Section */}
      <h1 className="text-3xl font-bold text-center Cardiology">Cardiology</h1>
      <h2 className="text-xl font-semibold text-center Cardiology mb-6">
        Consultant Cardiologist
      </h2>
      {/* 
      Doctor Image */}
      <div className="flex justify-center mb-6">
        <div className="Neurology">
          <img
            src="Drprasanth.jpg"
            class="consltnt-doctor-img"
            alt="Dr. PawanKalyan"
          />
        </div>
      </div>

      {/* Doctor Description */}
      <p className="text-center text-gray-600 mb-8">
        <strong className="Cardiology">Dr. Ramesh</strong> offers expert
        consultation and advanced treatment for all heart-related conditions.
      </p>

      {/* Services Offered */}
      <h3 className="text-2xl font-semibold Cardiology mb-4">
        Services Offered
      </h3>

      <ul className="space-y-4 text-gray-700 list-disc pl-6">
        <li>
          <strong>ECG & Echo Facility:</strong> On-site ECG and Echocardiography
          services for accurate and timely diagnosis.
        </li>
        <li>
          <strong>Hypertension & Heart Disease Management:</strong> Expert care
          for high blood pressure, coronary artery disease, and related cardiac
          problems.
        </li>
        <li>
          <strong>Chest Pain Evaluation:</strong> Advanced assessment for chest
          discomfort, breathlessness, or palpitations.
        </li>
        <li>
          <strong>Preventive Cardiology:</strong> Focused on early detection and
          lifestyle modification to prevent heart attacks and strokes.
        </li>
        <li>
          <strong>Cardiac Risk Assessment:</strong> Comprehensive evaluation for
          patients with diabetes, obesity, or family history of heart disease.
        </li>
      </ul>

      {/* Consultation Timings */}
      <div className="mt-8 p-4 rounded-xl text-center">
        <h3 className="text-xl font-semibold Cardiology mb-2">
          Consultation Timings
        </h3>
        <p className="text-gray-700">
          Every <strong>Wednesday & Saturday</strong> <br />
          From <strong>10:00 AM onwards</strong>
        </p>
      </div>
    </div>
  );
};

export default Cardiology;
